import React from 'react'
import {Route, useParams} from 'react-router-dom'
import RegistrationPageLayout from '../../layout/RegistrationPageLayout'

const RegistrationPageRoute = ({path, exact, component: Component, render, ...rest}: {
	path: string,
	exact?: boolean,
	component?: any,
	render?: any,
	rest?: any
}) =>
{
	const params = useParams()
	const matchProps = {match: {params}}
	return (
		<RegistrationPageLayout>
			<Component {...matchProps} />
		</RegistrationPageLayout>
	)
}

export default RegistrationPageRoute
